exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flex-column__row--full[data-v-f4f86742] {\n  position: relative;\n}", ""]);

// exports
